import { useEffect, useState } from 'react';

// Returns true when the user has `prefers-reduced-motion: reduce`.
// Listens for live changes (system setting toggled at runtime).
// SMIL <animate> tags do not honor the global tokens.css media rule
// (which only targets CSS animations/transitions), so loaders that
// use SVG <animate> must conditionally render them based on this.
export function useReducedMotion() {
  const [reduced, setReduced] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = (e) => setReduced(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
